import styled from 'styled-components'
import { IconButton } from '@astro-ui/components'

export const StyledOverlay = styled('div')`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 2;
  transition: background-color 0.3s ease;
  border-radius: 8px;
  padding: 10px;
  opacity: 0;
  text-align: center;
  cursor: all-scroll;
`

export const StyledIconButton = styled(IconButton)`
  position: absolute;
  bottom: 5px;
  right: 5px;
  background-color: white;
  z-index: 3;
  cursor: pointer;
  display: none;

  &:hover {
    background-color: white;
  }
`

export const StyledBoxImage = styled('div')`
  position: relative;
  display: flex;
  width: 120px;
  height: 120px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  border: 1px dashed #d3d3d3;
  background: #e9f1fc;

  &:hover > ${StyledOverlay} {
    opacity: 1; /* Make the overlay visible */
  }
  &:hover > ${StyledIconButton} {
    display: flex;
  }
`
